import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-public",
	templateUrl: "./public.component.html",
	styleUrls: ["./public.component.scss"],
})
export class PublicComponent implements OnInit {
	quickbooksAuthenticationResponse;
	connectionComplete: boolean = false;
	connectionFailure: boolean = false;

	source: string;

	constructor(public venueSvc: OOVenueService, private route: ActivatedRoute, private focuslink: FocuslinkService, public app: AppService) {}

	ngOnInit(): void {
		this.venueSvc.venueKey = +this.route.snapshot.paramMap.get("storeKey");

		if (this.route.snapshot.queryParamMap.get("code")) {
			this.source === "quickbooks";
			this.connectToQuickbooks(this.route.snapshot["_routerState"].url, this.route.snapshot.queryParamMap);
		} else {
			this.source === "uber";
		}

		if (this.venueSvc.venueKey && this.venueSvc.venueKey !== 0) {
			this.connectToUber();
		}
	}

	connectToUber() {
		// const clientId = 'cHTYj_Mp9OUK8Xaiby7fOlC-FKbONZEi';
		const clientId = "VC6Jy2atqBqfp-5gnet-OTfUhn-QpBOi";
		let redirectUri = window.location.hostname;
		if (redirectUri === "localhost") {
			redirectUri = `http://localhost:4200`;
		} else {
			redirectUri = `https://${redirectUri}`;
			if (!redirectUri.includes("onlineorder.focuspos.com")) {
				redirectUri = "https://onlineorder.focuspos.com";
			}
		}
		const state = btoa(
			JSON.stringify({
				venueKey: this.venueSvc.venueKey,
				appId: "uber",
				redirectUri: redirectUri,
			})
		);
		const uberUrl = `https://login.uber.com/oauth/v2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=eats.pos_provisioning`;
		console.log(uberUrl);
		window.open(uberUrl, "_blank");
	}

	connectToQuickbooks(url, queryParams: ParamMap) {
		const localhost = window.location.hostname === "localhost" ? true : false;

		const state = JSON.parse(atob(queryParams.get("state")));
		const body = {
			redirectUri: localhost ? `http://localhost:4200${url}` : `https://app.focuspos.com${url}`,
			financeIntegrationCompanyIdentifier: queryParams.get("realmId"),
			code: queryParams.get("code"),
			dealerKey: state.dealerKey,
			venueKey: state.venueKey,
			localhost: localhost,
		};
		this.focuslink
			.quickbooksOauthExchange(body)
			.then((response) => {
				this.connectionComplete = true;
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Connected to QuickBooks!` });
			})
			.catch((error) => {
				this.connectionFailure = true;
				this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `There was a problem connecting to QuickBooks` });
			});
	}
}
